// THIS FILE IS OVERWRITTEN WITH CORRECT VALUES DURING BUILD PROCESS
// (NOT FOR LOCALDED CONFIGURATION), SHOULD NOT BE EDITED
export const versionInfo = {
  buildTime:'?',
  gitHash:'?',
  branchName:'?',
  tag:'',
  version:'?'
};
